import React from 'react';
import PropTypes from 'prop-types';

// FSSAI vegan mark (India). Regulated colours when active; greyed when inactive (e.g. unselected filter).
const FssaiVeganIcon = ({ className, width, height, active }) => {
  const colour = active ? '#65ff1b' : '#bbb';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 52.917 52.917"
    >
      <rect
        x=".85592"
        y=".85592"
        width="51.205"
        height="51.205"
        fill="none"
        stroke={colour}
        strokeWidth="1.7118"
      />
      <path
        d="m9.3401 11.052 17.118 23.966 17.118-23.966"
        fill="none"
        stroke={colour}
        strokeWidth="3.7095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m34.261 47.16v-6.8473h1.18l1.9778 4.0053 2e-6 -4.0053h1.1301v6.8473h-1.1301l-1.9778-4.0053 2.7e-5 4.0053zm-3.637-6.8473-1.7904 6.8473h1.2028l0.36377-1.3321h1.5401l0.33538 1.3321h1.1923l-1.7711-6.8473zm0.54056 1.9821 0.68161 2.75h-1.3632zm-4.0425 0.27026h1.0223s-0.0025-0.7209 0-1.0459c0.0081-1.0631-1.2093-1.2065-1.4102-1.2065h-1.2104c-0.24517 0-1.1635 0.32371-1.1635 1.2065v4.3422c0 0.71188 0.58678 1.2986 1.1635 1.2986h1.2104c0.7713 0 1.4775-0.56844 1.4775-1.2986v-2.2269h-1.9594v0.82263h0.8697s-6.4e-5 0.94551-6.4e-5 1.4043c0 0.21278-0.3246 0.47598-0.56405 0.47598-0.20761 0-0.38086-1e-5 -0.62282-1e-5 -0.22439 0-0.47601-0.2516-0.47601-0.47597 0-0.98812 4.1e-5 -4.072 4.1e-5 -4.072 4e-6 -0.29553 0.12182-0.56701 0.47597-0.56701h0.62282c0.43568 0 0.56412 0.27074 0.56412 0.56701zm-7.4037-2.2523h3.7253v0.94788h-2.4914v2.1036h1.5982v0.83438h-1.6218v2.1036h2.4561v0.85789l-3.6731-3.2e-5zm-5.351 0h1.3462l0.83098 4.6203 0.9307-4.6203h1.396l-1.5955 6.8473-1.396-1.1e-5z"
        fill={colour}
        stroke={colour}
        strokeWidth=".090317"
      />
      <path
        d="m26.234 20.461v-4.2895s-5.3437-1.6739-4.3745-5.7314c1.5428 1.2263 4.178 4.4487 4.3745 5.1977v-2.7129c0.0869-0.75751-1.7927-1.1079-1.2728-3.7742 1.3909 0.57073 1.2728 2.7933 1.3908 3.4386 0.48339-1.7499 1.4007-2.8626 2.3044-3.6028 0.84565 1.9598-1.4778 3.484-2.0375 3.9929 0 1.1487-0.0975 2.6393-0.0975 2.6393s3.6838-6.0004 6.015-7.0632c0.9086 2.6968-3.14 4.7851-6.0255 7.2878-0.06935 1.1817 0.11763 2.9063 0.15455 4.5977 0.0044 0.2022-0.43139 0.02021-0.43139 0.02021z"
        fill={colour}
        stroke={colour}
        strokeWidth=".0015518"
      />
    </svg>
  );
};

FssaiVeganIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  active: PropTypes.bool,
};

FssaiVeganIcon.defaultProps = {
  height: '100%',
  width: '100%',
  active: true,
};

export default FssaiVeganIcon;
